/**
 * Application Constants
 * Centralized location for constants used across the application
 */

/**
 * Available merchant statuses
 * Used in filters, export modals, and status dropdowns
 */
export const AVAILABLE_STATUSES = [
  'New',
  'Approved',
  'Declined',
  'Closing',
  'Statement Review',
  'Quoting',
  'Need Full Package',
  'Already Has Provider',
  'Application Sent',
  'Esign',
  'Underwriting'
];

/**
 * Default pagination settings
 * Used across components for consistent pagination behavior
 */
export const DEFAULT_PAGE_SIZE = 50;

/**
 * Debounce configuration for different filter types
 * Optimized delays for better performance and user experience
 */
export const DEBOUNCE_CONFIG = {
  TEXT_INPUT: 700,      // Business Name, Gateway ID - faster for typing
  DATE_RANGE: 600,      // Date pickers - keep current for calendar interactions
  STATUS_SELECT: 400,   // Status dropdown - immediate response
  COMBINED_SEARCH: 900  // Multi-filter search - balanced
};

/**
 * Configuration for infinite scroll settings
 * Used in components with infinite scroll functionality
 */
export const SCROLL_CONFIG = {
  INITIAL_LOAD_SIZE: 20,          // Number of items to load initially
  LOAD_MORE_SIZE: 10,             // Number of items to load on each scroll
  SCROLL_THRESHOLD: 100,          // Distance from bottom to trigger load more (px)
  THROTTLE_DELAY: 100,            // Throttle delay for scroll events (ms)
};

/**
 * Auth0 user session flags and error indicators
 * Used across authentication helpers and UI messaging
 */
export const USER_NOT_FOUND_FLAG = 'showUserNotFoundMessage';

/**
 * Invalid grant error codes
 * Used in authentication helpers to check for invalid sessions
 */
export const SESSION_INVALID_ERROR_CODES = [
  'invalid_grant',
  'login_required',
  'consent_required',
  'missing_refresh_token',
];

/**
 * Blocked user error codes and messages
 * Used to detect when a user is blocked in Auth0 and show appropriate error messages
 */
export const BLOCKED_USER_ERROR_CODES = [
  'access_denied',
  'unauthorized',
  'blocked',
  'user_blocked',
  'account_blocked',
  'forbidden',
  'user_is_blocked',
];

/**
 * Flag to store blocked user error message in localStorage
 */
export const BLOCKED_USER_FLAG = 'showBlockedUserMessage';

/**
 * Company names used in merchant submission flows
 */
export const AUTHORIZE_NET_COMPANY = "Authorize.net";
export const CYBERSOURCE_COMPANY = "CyberSource";
